import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import PortalIdParser from 'PortalIdParser';

/*
 * NOTE: This endpoint will hit Salesforce under the covers via a call to:
 * `quoteClient.findApprovedApolloQuotesByHubId(hubId)`, only when there are valid
 * approved quotes for this hub. This endpoint should be hit sparingly as
 * our Salesforce API integration has rate limiting.
 *
 * Context: https://git.hubteam.com/HubSpotProtected/UpgradeCatalog/issues/230#issuecomment-464922
 *
 */
export const fetchActiveQuotes = () => {
  const url = `${getFullUrl('app-api', {
    hubletOverride: na1
  })}/quotes/v1/quotes/approved/hub/${PortalIdParser.get()}`;
  return http.get(url);
};